import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { SITE_URL } from '@/data/blogSeoMetadata';
import { productFacts } from '@/data/productFacts';
import { usePublicSeo } from './usePublicSeo';
import styles from './PublicPage.module.css';

const llmInfo = {
  title: 'CalorieScience Product Facts | Software, Audience and Pricing',
  description: 'A factual overview of CalorieScience: its audience, nutrition workflows, client app, pricing information and product limitations.',
  eyebrow: 'Product information',
};

export default function PublicPage() {
  const { pathname } = useLocation();
  const found = pathname === '/llm-info';
  const info = found
    ? llmInfo
    : { title: 'Page Not Found | CalorieScience', description: 'This page could not be found. Explore CalorieScience’s product pages and practitioner guides.', eyebrow: '404' };
  const schemas = found ? [{
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name: info.title.split(' | ')[0], item: `${SITE_URL}${pathname}` },
    ],
  }] : [];
  usePublicSeo(pathname, info.title, info.description, schemas, !found);

  return <div className="min-h-screen flex flex-col"><Navbar />
    <main className={styles.main}>
      <header className={styles.hero}><p className={styles.eyebrow}>{info.eyebrow}</p><h1>{info.title.split(' | ')[0]}</h1><p>{info.description}</p></header>
      {found && <article>
        <h2>Product</h2><p>CalorieScience is software for nutrition practitioners. Website: <a href={`${SITE_URL}/`}>{SITE_URL}</a>. Operator: {productFacts.legalName}.</p>
        <section className={styles.section}>
          <h2>Audience</h2><p>Dietitians, nutritionists, health and fitness professionals, and nutrition teams working within their professional scope.</p>
          <h2>Workflows</h2><p>Client records; intake questionnaires; manual, automated and AI-assisted meal planning; recipes and nutrition analysis; biomarker information for professional review; appointments; invoices; client follow-up through CalorieScience Companion.</p>
          <h2>Product distinction</h2><p>The platform connects biomarker information and dietary context with practitioner-reviewed nutrition planning and practice administration.</p>
          <h2>Pricing</h2><p>Current GBP subscriptions and allowances are available from the CalorieScience team.</p>
          <h2>Limits</h2><p>CalorieScience is not a diagnostic tool or medical device. AI outputs need practitioner review. The Companion app requires a connection to a practitioner using CalorieScience. HIPAA compliance is described as in progress, not complete.</p>
          <h2>Contact and further reading</h2><p><a href={`mailto:${productFacts.contactEmail}`}>{productFacts.contactEmail}</a> · <Link to="/#about-us">About</Link> · <Link to="/#blogs">Guides</Link> · <Link to="/privacy">Privacy</Link></p>
        </section>
      </article>}
      {!found && <p>The address may have changed or the page may no longer exist. <Link to="/">Return home</Link> or <Link to="/#blogs">browse the blog</Link>.</p>}
      {found && <div className={styles.actions}><Link to="/signup">Get started</Link><a href="/#ready-to-grow-practice">Book a demo</a></div>}
    </main><Footer /></div>;
}
